module.exports = __webpack_public_path__ + "img/70.4a47c8c4.png";